export default {
  colunasGestaoContainers: [
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'referenciaInterna', field: 'referenciaInterna' },
    { label: 'container', field: 'numeroContainer' },
    { label: 'house', field: 'numeroHouse' },
    { label: 'master', field: 'numeroMaster' },
    { label: 'tipoContainer', field: 'tipoContainer' },
    { label: 'armador', field: 'nomeArmador' },
    { label: 'lacre', field: 'numeroLacre' },
    { label: 'dataChegada', field: 'dataChegadaContainer' },
    { label: 'freetime', field: 'freetime' },
    { label: 'vencimentoFreetime', field: 'dataVencimentoFreetime' },
  ],
  colunasProdutos: [
    { label: 'ncm', field: 'ncm' },
    { label: 'sequencia', field: 'ncmSeq' },
    { label: 'produto', field: 'produto' },
    { label: 'descricaoDetalhada', field: 'descricao' },
    { label: 'unidadeMedida', field: 'unidadeMedida' },
    { label: 'moeda', field: 'moeda' },
    { label: 'empresa', field: 'nomeCliente' },
  ],
  colunasSAP: [
    { label: 'referencia', field: 'referenciaCliente' },
    { label: 'processo', field: 'referenciaTrust' },
    { label: 'status', field: 'status' },
    { label: 'solicitadoPor', field: 'usuario' },
    { label: 'Tipo Importação', field: 'tipoImportacao' },
    { label: 'Finalidade', field: 'finalidade' },
    { label: 'Empresa', field: 'empresaImportador' },
    { label: 'Solicitado em', field: 'dataSolicitacao' },
    { label: 'ultimaAtualizacao', field: 'updatedAt' },
  ],
  colunasUsuarios: [
    { label: 'nome', field: 'nome' },
    { label: 'email', field: 'email' },
    { label: 'Tipo', field: 'tipo' },
    { label: 'Criado em', field: 'dataCriacao' },
    { label: 'ultimoAcesso', field: 'ultimoAcesso' },
  ],
  colunasPendentes: [
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'referenciaTrust', field: 'referenciaTrust' },
    { label: 'dataAbertura', field: 'dataAbertura' },
    { label: 'eta', field: 'eta' },
    { label: 'cliente', field: 'nomePessoa' },
    { label: 'responsavel', field: 'responsavel' },
    { label: 'dataEmbarque', field: 'dataEmbarque' },
    { label: 'bl', field: 'possuiConhecimento' },
    { label: 'container', field: 'possuiContainer' },
    { label: 'invoice', field: 'possuiInvoice' },
  ],
  colunasGestaoLI: [
    { label: 'situacao', field: 'situacao' },
    { label: 'li', field: 'codigoLI' },
    { label: 'dataSituacao', field: 'dataSituacao' },
    { label: 'referenciaCliente', field: 'referenciaCliente' },
    { label: 'orgaoAnuente', field: 'orgaoAnuente' },
    { label: 'dataReg', field: 'dataRegistro' },
    { label: 'dataProtocolo', field: 'dataProtocolo' },
  ],
  colunasEstoque: [
    { label: 'depositante', field: 'depositante' },
    { label: 'codigoDocumento', field: 'codigoDocumento' },
    { label: 'lote', field: 'lote' },
    { label: 'numeroLote', field: 'numeroLote' },
    { label: 'numeroLoteFabricacao', field: 'numeroLoteFabricacao' },
    { label: 'codigoProduto', field: 'codigoProduto' },
    { label: 'descricaoProduto', field: 'descricaoProduto' },
    { label: 'dataFabricacao', field: 'dataFabricacao' },
    { label: 'dataEmissao', field: 'dataEmissao' },
    { label: 'dataMovimentacao', field: 'dataMovimentacao' },
    { label: 'dataVencimento', field: 'dataVencimento' },
    { label: 'codigoPallet', field: 'codigoPallet' },
    { label: 'valorUnitario', field: 'valorUnitario' },
    { label: 'tipoUnidade', field: 'tipoUnidade' },
    { label: 'quantidadeAtual', field: 'quantidadeAtual' },
    { label: 'quantidadeBloqueada', field: 'quantidadeBloqueada' },
    { label: 'quantidadeEmpenhado', field: 'quantidadeEmpenhado' },
    { label: 'quantidadeReserva', field: 'quantidadeReserva' },
    { label: 'situacao', field: 'situacao' },
    { label: 'pesoBruto', field: 'pesoBruto' },
    { label: 'armazenadoEm', field: 'armazenadoEm' },
  ],
  colunasIncentivoFiscal: [
    { label: 'processo', field: 'processo' },
    { label: 'numeroNota', field: 'numeroNotaFiscal' },
    { label: 'Data', field: 'dataCadastro' },
    { label: 'codigoProduto', field: 'codigoProduto' },
    { label: 'descricaoProduto', field: 'descricaoProduto' },
    { label: 'quantidade', field: 'quantidadeProduto' },
    { label: 'unidadeMedida', field: 'unidadeMedida' },
    { label: 'valorNota', field: 'valor' },
    { label: 'declaracaoImportacao', field: 'codigoDI' },
    { label: 'icmsPago', field: 'icmsPago' },
    { label: 'descontoIcmsPago', field: 'descontoIcmsPago' },
    { label: 'formaDesconto', field: 'formaDesconto' },
    { label: 'situacao', field: 'situacao' },
    { label: 'pctBaseCliente', field: 'pctCliente' },
    { label: 'pctEmpresa', field: 'pctEmpresa' },
    { label: 'porcentagemCliente', field: 'pctCliente' },
    { label: 'valorCliente', field: 'valorCliente' },
    { label: 'Tipo Importação', field: 'tipoImportacao' },
  ],
  colunasProcessosAfiliados: [
    { label: 'statusEmbarque', field: 'codigoStatusEmbarque' },
    { label: 'processo', field: 'referenciaCliente' },
    { label: 'empresa', field: 'cliente' },
    { label: 'dataEmbarque', field: 'dataEmbarque' },
    { label: 'previsaoChegada', field: 'eta' },
    { label: 'dataChegada', field: 'dataChegada' },
    { label: 'valorAduaneiroEstimado', field: 'valorAduaneiroEstimado' },
  ],
  colunasPrevisaoDemandaDomestica: [
    {
      label: 'referenciaTrust',
      field: 'referenciaTrust',
    },
    {
      label: 'cliente',
      field: 'nomeCliente',
    },
    {
      label: 'pesoBruto',
      field: 'pesoBruto',
    },
    {
      label: 'dataChegada',
      field: 'dataChegada',
    },
    {
      label: 'portoDestino',
      field: 'portoDestino',
    },
    {
      label: 'segmentoProduto',
      field: 'segmentoProduto',
    },
    {
      label: 'produto',
      field: 'produto',
    },
    {
      label: 'tipoContainer',
      field: 'tipoContainer',
    },
    {
      label: 'container',
      field: 'container',
    },
    {
      label: 'quantidadeContainers',
      field: 'quantidadeContainers',
    },
    {
      label: 'valorProcesso',
      field: 'valorProcesso',
    },
    {
      label: 'tipoCarga',
      field: 'tipoCarga',
    },
  ],
  colunasMercadoHoje: [
    {
      label: 'codigoProcesso',
      field: 'codigoProcesso',
    },
    {
      label: 'filial',
      field: 'codigoFilial',
    },
    {
      label: 'dataAbertura',
      field: 'dataAbertura',
    },
    {
      label: 'ncm',
      field: 'ncm',
    },
    {
      label: 'sequencia',
      field: 'sequencia',
    },
    {
      label: 'produto',
      field: 'produto',
    },
    {
      label: 'valor',
      field: 'valor',
    },
    {
      label: 'incoterm',
      field: 'incoterm',
    },
    {
      label: 'unidadeMedida',
      field: 'unidadeMedida',
    },
    {
      label: 'moeda',
      field: 'moeda',
    },
    {
      label: 'exportador',
      field: 'exportador',
    },
    {
      label: 'tipoImportacao',
      field: 'tipoImportacao',
    },
    {
      label: 'fabricante',
      field: 'fabricante',
    },
    {
      label: 'pesoLiquido',
      field: 'pesoLiquido',
    },
    {
      label: 'pesoBruto',
      field: 'pesoBruto',
    },
    {
      label: 'quantidade',
      field: 'quantidade',
    },
    {
      label: 'paisOrigem',
      field: 'paisOrigem',
    },
    {
      label: 'nomeCliente',
      field: 'nomeCliente',
    },
    {
      label: 'prazoPagamento',
      field: 'prazoPagamento',
    },
  ],
  colunasCambio: [],
  colunasProcessos: [],
  colunasAgendadorRelatorio: [],
  colunasMensageiro: [],
  colunasCustoArmazem: [
    { label: 'CNPJ', field: 'cnpj' },
    { label: 'nomeEmpresa', field: 'nomeEmpresa' },
    { label: 'codigo', field: 'codigoCrc' },
    { label: 'status', field: 'estadoCrc' },
    { label: 'dataMovimento', field: 'dataMovimento' },
    { label: 'dataInicio', field: 'dataInicio' },
    { label: 'dataFim', field: 'dataFim' },
    { label: 'descricaoServico', field: 'descricaoServico' },
    { label: 'quantidadeServico', field: 'quantidadeServico' },
    { label: 'valorServico', field: 'valorServico' },
    { label: 'valorCalculado', field: 'valorCalculado' },
  ],
};
